export default {"src":"/_next/static/media/confetti.b5e6aade.gif","height":1240,"width":1700};